// extracted by mini-css-extract-plugin
export default {"data-source-form-section":"DataSourceForm_data-source-form-section__RPQjP"};